import Axios from "../axios";
import {musicLibraryApiConstants} from "../constants/ApiConstant";

// Backend integration for the Music Library (Music Studio).
//
// Base path: /api/v1/app/musicLibrary. The audio file is uploaded to storage
// separately (see FileService.fileUpload) and only the resulting `s3Url` +
// metadata are stored here. The school / uploading admin are resolved from the
// auth token, so nothing extra is sent.
//
//   POST   /app/musicLibrary        create a track  → 201 (no body)
//   GET    /app/musicLibrary        list active     → [{ id, name, ... }]
//   GET    /app/musicLibrary/{id}   detail (active) → { id, name, ... }

// Create a track. `name` and `s3Url` are required; `album` / `artist` optional.
// Resolves with the raw axios response (201 Created, empty body).
export async function createMusic({name, album, artist, s3Url}) {
    const payload = {
        name: (name || "").trim(),
        album: album ? album.trim() : null,
        artist: artist ? artist.trim() : null,
        s3Url,
    };
    return Axios.post(musicLibraryApiConstants.SAVE_MUSIC, payload);
}

// List every active track (backend returns newest first). Always resolves with
// an array — an empty one when the library is empty.
export async function listMusic() {
    const response = await Axios.get(musicLibraryApiConstants.LIST_MUSIC);
    return Array.isArray(response?.data) ? response.data : [];
}

// Fetch a single active track by id. Rejects (404) when it doesn't exist or is
// inactive.
export async function getMusicDetail(id) {
    const response = await Axios.get(`${musicLibraryApiConstants.MUSIC_DETAIL}/${id}`);
    return response?.data || null;
}
